var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { BoostStatusContainer } from './common/BoostStatusContainer';
import { BoostMarkdown } from './common/BoostMarkdown';
import { SnackBar } from 'common-uicomponents/components/SnackBar';
import { isErrorHTTP, isSuccessHTTP } from 'boost-api/APIRestClient';
import { styleMap } from 'lit/directives/style-map.js';
import { CerumBadge } from 'common-uicomponents/components/CerumBadge';
import { MembersignupAPI } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { BoostMetoderTilgjengeligEtterInnloggAPI } from 'boost-api/boost/app/boost_metoder_tilgjengelig_etter_innlogg/BoostMetoderTilgjengeligEtterInnloggAPI';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
import { ewExerciseProfileJson } from 'boost-api/schemas/ewExerciseProfileJson';
let BoostPortalChooseMembership = class BoostPortalChooseMembership extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    constructor() {
        super(...arguments);
        this.memberships = [];
        this.filteredMemberships = [];
        this.isSponsor = false;
        this.isDirectLink = false;
        this.membershipProperties = [];
        this.selectedProperties = [];
        this.dropdownIsVisible = false;
    }
    static get is() {
        return 'boost-portal-choose-membership';
    }
    static get styles() {
        return css `
            .membership {
                margin-bottom: 10px;
                padding: 1rem;
                border-radius: 4px;
                color: var(--portalCardForeground, #111);
                background-color: var(--portalCardBackground, #fefefe);
                transition: opacity 0.2s linear;
                position: relative;
                box-shadow:
                    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
                    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
                cursor: pointer;
                display: flex;
                flex-direction: column;
            }

            .membership:hover {
                background-color: var(--portalCardBackgroundHover, #ececec);
                transition: 300ms ease-out;
            }

            .membership-info {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex: 1;
                flex-direction: row;
            }

            .membership .membership-title {
                flex: 1;
                font-size: 20px;
            }

            .membership .membership-cost {
                font-size: 20px;
                margin-right: 6px;
                padding-top: 6px;
            }

            .membership .membership-description {
                border-top: 1px solid #ececec;
                margin-top: 2rem;
                font-size: 14px;
            }

            vaadin-select {
                width: 100%;
            }

            h4 {
                color: var(--boost-font-color-dark);
                font-weight: 500;
                margin-bottom: 10px;
            }

            ul {
                list-style: none;
                padding: 0;
                margin: 0;
            }

            .membership.hidden {
                display: none;
            }

            .membership.visuallyhidden {
                opacity: 0;
            }

            .check {
                display: none;
            }

            .active .check {
                display: block;
                position: absolute;
                top: -4px;
                color: #f6f6f6;
                right: -10px;
                background-color: var(--portalButtonSuccessBackground, #32be69) !important;
                border-radius: 50%;
                width: 30px;
                height: 30px;
            }

            .active .check svg {
                fill: var(--portalButtonSuccessForeground, #74ff74);
            }

            cerum-badge {
                cursor: pointer;
                font-size: 12px;
            }

            .selected-property {
                --cerum-badge-background-color: var(--portalCardBackground, #263651);
                --cerum-badge-color: var(--portalCardForeground, #fafafa);
            }

            .filter-button {
                width: fit-content;
                display: flex;
                align-items: center;
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
                background-color: #122b4f;
                color: #fff;
                border-radius: 14px;
                padding: 4px 10px;
                font-size: 16px;
                margin-bottom: 8px;
                height: 30px;
                align-self: end;
                cursor: pointer;
            }

            .property-container {
                display: flex;
                max-width: 100%;
                flex-flow: wrap;
                margin-bottom: 10px;
                gap: 2px;
            }

            .property-text-button-container {
                display: flex;
                justify-content: space-between;
                padding: 8px 0px 8px 0px;
            }

            .dropdown-visible {
                color: #fff;
                min-width: 12px;
                width: 12px;
                height: 13px;
                margin-left: 14px;
            }

            .dropdown-visible-rotate {
                transform: rotate(90deg);
                margin-right: 3px;
            }

            .price-type {
                font-size: 14px;
                padding: 4px;
                border-radius: 4px;
                background-color: whitesmoke;
                border: 1px solid #e4e4e4;
                color: #111;
            }

            @media only screen and (max-width: 1100px) {
                .membership {
                    padding: 10px;
                    margin-top: 8px;
                }

                .membership .membership-title {
                    font-size: 21px;
                    font-weight: 100;
                    margin-bottom: 0;
                    margin-right: 0;
                }

                .membership .membership-cost {
                    font-size: 22px;
                    font-weight: 100;
                    margin-bottom: 0px;
                    align-self: center;
                }

                .active .check {
                    top: -10px;
                    width: 26px;
                    height: 26px;
                }

                svg {
                    width: 26px;
                    height: 26px;
                }

                .property-text-button-container {
                    display: block;
                }

                .membership-info {
                    flex-direction: column;
                }

                .membership .membership-description {
                    margin-top: 1rem;
                }
            }
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.filteredMemberships = this._filterMemberships();
    }
    /** @override */ render() {
        return html ` ${this._isMembershipPropertiesLength()
            ? this._renderFilterText()
            : this._renderFilterButton()}
        ${this.dropdownIsVisible
            ? html `<div class="property-container">${this._renderAvailableMembershipProperties()}</div>`
            : nothing}
        ${this.memberships.length ? this._renderMemberships() : this._renderIsEmpty()}`;
    }
    _renderFilterText() {
        if (this.membershipProperties.length) {
            return html `<h4>${this.boostTranslate('filter-membership')}</h4>
                <div class="property-container">${this._renderAvailableMembershipProperties()}</div>`;
        }
        return html `<h4>${this.boostTranslate('choose-membership')}</h4>`;
    }
    _renderFilterButton() {
        return html `<div class="property-text-button-container">
            <h4>${this.boostTranslate('available-filters')}</h4>
            <div class="filter-button" @click="${() => this._onToggleFilterButton()}">
                <span> ${this.boostTranslate('choose-filter')} </span>
                <svg
                    class="dropdown-visible  ${this.dropdownIsVisible ? 'dropdown-visible-rotate' : ''}"
                    viewBox="0 0 24 24"
                >
                    <path
                        d="M5.5.75l10.72 10.72a.749.749 0 010 1.06L5.5 23.25"
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="3"
                    ></path>
                </svg>
            </div>
        </div>`;
    }
    _isMembershipPropertiesLength() {
        return this.membershipProperties.length <= 4;
    }
    _onToggleFilterButton() {
        this.dropdownIsVisible = !this.dropdownIsVisible;
    }
    _renderStatusContainer(memberships) {
        if (this.selectedProperties.length && !memberships.length) {
            return html ` <boost-status-container type="warning">
                ${this.boostTranslate('filter-status-container-warning')}
            </boost-status-container>`;
        }
        if (!this.selectedDepartmentId) {
            return html `
                <boost-status-container type="info">
                    ${this.boostTranslate('department-status-container-info')}
                </boost-status-container>
            `;
        }
        return this._renderIsEmpty();
    }
    _renderIsEmpty() {
        return html ` <boost-status-container type="warning">
            ${this.boostTranslate('membership-status-container-warning')}
        </boost-status-container>`;
    }
    _loadMemberships() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.selectedDepartmentId) {
                return;
            }
            const groupIds = this.selectedProperties.map((property) => property);
            const membershipsResult = yield MembersignupAPI.getV1BoostsignupDepartmentsMembershipsUsingDepartmentid(String(this.selectedDepartmentId), { include_hidden: true, group_ids: groupIds });
            if (isErrorHTTP(membershipsResult)) {
                SnackBar.pushError(membershipsResult.error);
                return;
            }
            this.dispatch(BoostPortalStore.Actions.SetMemberships(membershipsResult.sort(this._membershipsComparator)));
        });
    }
    _membershipsComparator(lhs, rhs) {
        return lhs.is_featured === rhs.is_featured ? 0 : lhs.is_featured ? -1 : 1;
    }
    _getMembershipClass(membership) {
        if (!this.selectedMembershipId) {
            return 'membership';
        }
        const classes = ['membership'];
        if (membership.id === this.selectedMembershipId) {
            classes.push('active');
        }
        else {
            classes.push('visuallyhidden', 'hidden');
        }
        return classes.join(' ');
    }
    _selectedMembership(membershipId) {
        if (this.isDirectLink &&
            this.memberships.some((membership) => membership.id === this.selectedMembershipId)) {
            return;
        }
        if (membershipId === this.selectedMembershipId) {
            this.dispatch(BoostPortalStore.Actions.SetSelectedMembershipId(undefined));
        }
        else {
            this.dispatch(BoostPortalStore.Actions.SetSelectedMembershipId(membershipId));
        }
    }
    _membershipsObserver() {
        if (!this.memberships.length) {
            return;
        }
        if (this.memberships.length === 1 && !this.selectedProperties.length && !this.isDirectLink) {
            this._selectedMembership(this.memberships[0].id);
        }
        this._checkIfMembershipIsValid(this.selectedMembershipId);
    }
    _selectedMembershipIdObserver() {
        if (!this.selectedMembershipId) {
            return;
        }
        this._checkIfMembershipIsValid(this.selectedMembershipId);
    }
    _checkIfMembershipIsValid(membershipId) {
        if (!membershipId || !this.memberships.length) {
            return;
        }
        if (!this.memberships.flatMap((membership) => membership.id).includes(membershipId) &&
            !this.isDirectLink) {
            this.dispatch(BoostPortalStore.Actions.SetSelectedMembershipId(undefined));
            SnackBar.push({
                title: 'En feil har oppstått',
                subtitle: 'Medlemskapet du ønsker er ikke lengre tilgjengelig. Velg et annet medlemskap',
                type: 'danger',
            });
        }
    }
    _getMemberhipPropertyClasses(propertyId) {
        const classes = [];
        if (this._isSelectedProperty(propertyId)) {
            classes.push('selected-property');
        }
        return classes.join(' ');
    }
    _renderAvailableMembershipProperties() {
        if (this.isDirectLink) {
            return;
        }
        return this.membershipProperties.map((property) => html `<div style="margin:3px 0px">
                    <cerum-badge
                        @click="${() => this._propertyChanged(property.id)}"
                        class="${this._getMemberhipPropertyClasses(property.id)}"
                        type="info"
                        >${property.name}</cerum-badge
                    >
                </div> `);
    }
    _filterActiveCategory() {
        return __awaiter(this, void 0, void 0, function* () {
            const filterDocument = yield MembersignupAPI.getV1BoostsignupDepartmentsMembershipsGroups();
            if (isSuccessHTTP(filterDocument)) {
                this.membershipProperties = filterDocument.filter((property) => property.is_active);
            }
        });
    }
    _isSelectedProperty(property) {
        return this.selectedProperties.find((selectedProperty) => property === selectedProperty);
    }
    _propertyChanged(propertyId) {
        if (this._isSelectedProperty(propertyId)) {
            this.selectedProperties = this.selectedProperties.filter((selectedProperty) => selectedProperty !== propertyId);
            this.dispatch(BoostPortalStore.Actions.SetSelectedMembershipId(undefined));
            return;
        }
        this.selectedProperties.push(propertyId);
        this.requestUpdate('selectedProperties');
    }
    _isValidSponsorMemberships(membership) {
        if (membership.id === this.selectedMembershipId) {
            return true;
        }
        if (membership.temporary === false && membership.is_direct_link_only === false) {
            return true;
        }
        if (membership.temporary !== false && membership.is_direct_link_only !== false) {
            return true;
        }
        return false;
    }
    _getMembershipStyles() {
        if (this.isDirectLink) {
            return { cursor: 'auto' };
        }
        return { cursor: 'pointer' };
    }
    _filterMemberships() {
        if (this.isDirectLink) {
            const membership = this.memberships.find((membership) => membership.id === this.selectedMembershipId);
            if (membership) {
                return [membership];
            }
            return [];
        }
        if (this.isSponsor) {
            return this.memberships.filter((membership) => this._isValidSponsorMemberships(membership));
        }
        if (this.loggedInProfile) {
            return this.memberships
                .filter((membership) => !membership.test_membership)
                .filter((membership) => !membership.is_direct_link_only);
        }
        return this.memberships.filter((membership) => !membership.is_direct_link_only);
    }
    _renderMemberships() {
        const filteredMemberships = this._filterMemberships();
        if (!filteredMemberships.length) {
            return this._renderStatusContainer(filteredMemberships);
        }
        return html `${filteredMemberships.map((membership) => this._renderMembership(membership))} `;
    }
    _renderMembership(membership) {
        var _a;
        return html `
            <div
                style="${styleMap(this._getMembershipStyles())}"
                class="${this._getMembershipClass(membership)}"
                @click="${() => this._selectedMembership(membership.id)}"
            >
                <div class="check">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:svgjs="http://svgjs.com/svgjs"
                        viewBox="0 0 140 140"
                        width="30"
                        height="30"
                    >
                        <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
                            <path
                                d="M18.48,6.449a1.249,1.249,0,0,0-1.747.265l-5.924,8.04L7.042,11.74a1.251,1.251,0,0,0-1.563,1.953l4.783,3.826a1.263,1.263,0,0,0,1.787-.235l6.7-9.087A1.25,1.25,0,0,0,18.48,6.449Z"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="0"
                            ></path>
                        </g>
                    </svg>
                </div>
                <div class="membership-info">
                    <div class="membership-title">${membership.title}</div>

                    <div class="membership-cost">
                        kr ${String(membership.cost_included_vat).replace('.', ',')}
                        <span class="price-type">
                            ${this.capitalizeFirstLetter(this.boostTranslate(membership.temporary ? 'one-time' : 'per-month'))}
                        </span>
                    </div>
                </div>
                ${membership.description
            ? html `<div class="membership-description">
                          <boost-markdown
                              elementId="${membership.id}"
                              markdown="${(_a = membership.description) !== null && _a !== void 0 ? _a : ''}"
                          ></boost-markdown>
                      </div>`
            : ''}

                <div class="property-container">
                    ${this._renderMembershipProperties(membership.group_ids)}
                </div>
            </div>
        `;
    }
    capitalizeFirstLetter(input) {
        if (!input) {
            return '';
        }
        return input.charAt(0).toUpperCase() + input.slice(1);
    }
    _renderMembershipProperties(groupIds) {
        return groupIds.map((groupId) => {
            const membershipProperty = this.membershipProperties.find((property) => property.id === groupId);
            return html ` <cerum-badge type="info">${membershipProperty === null || membershipProperty === void 0 ? void 0 : membershipProperty.name}</cerum-badge>`;
        });
    }
    _sessionObserver() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.session) {
                return;
            }
            const profileResult = yield BoostMetoderTilgjengeligEtterInnloggAPI.getExerciseProfile({
                session: this.session,
            });
            if (isErrorHTTP(profileResult)) {
                SnackBar.pushError(profileResult.error);
                return;
            }
            this.dispatch(BoostPortalStore.Actions.SetLoggedInProfile(profileResult));
        });
    }
    _filteredMembershipsObserver() {
        this.dispatchEvent(new CustomEvent('filtered-memberships-changed', {
            detail: { value: this.filteredMemberships },
        }));
    }
    /** @override */ updated(changedProperties) {
        changedProperties.forEach((_oldValue, propertyName) => {
            switch (propertyName) {
                case 'session':
                    this._sessionObserver();
                    break;
                case 'token':
                    this._filterActiveCategory();
                    break;
                case 'memberships':
                    this._membershipsObserver();
                    this.filteredMemberships = this._filterMemberships();
                    break;
                case 'selectedMembershipId':
                    this._selectedMembershipIdObserver();
                    break;
                case 'selectedDepartmentId':
                case 'selectedProperties':
                    this._loadMemberships();
                    break;
                case 'filteredMemberships':
                    this._filteredMembershipsObserver();
                    break;
                case 'isDirectLink':
                case 'loggedInProfile':
                case 'isSponsor':
                    this.filteredMemberships = this._filterMemberships();
                    break;
            }
            super.updated(changedProperties);
        });
    }
};
BoostPortalChooseMembership._deps = [BoostStatusContainer, BoostMarkdown, CerumBadge];
__decorate([
    reduxBind(BoostPortalStore.path('memberships')),
    state(),
    __metadata("design:type", Array)
], BoostPortalChooseMembership.prototype, "memberships", void 0);
__decorate([
    state(),
    __metadata("design:type", Array)
], BoostPortalChooseMembership.prototype, "filteredMemberships", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedDepartmentId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalChooseMembership.prototype, "selectedDepartmentId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedMembershipId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalChooseMembership.prototype, "selectedMembershipId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('token')),
    state(),
    __metadata("design:type", String)
], BoostPortalChooseMembership.prototype, "token", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('session')),
    state(),
    __metadata("design:type", String)
], BoostPortalChooseMembership.prototype, "session", void 0);
__decorate([
    property({ type: Boolean, attribute: 'is-sponsor' }),
    __metadata("design:type", Boolean)
], BoostPortalChooseMembership.prototype, "isSponsor", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('isDirectLink')),
    state(),
    __metadata("design:type", Boolean)
], BoostPortalChooseMembership.prototype, "isDirectLink", void 0);
__decorate([
    state(),
    __metadata("design:type", Array)
], BoostPortalChooseMembership.prototype, "membershipProperties", void 0);
__decorate([
    state(),
    __metadata("design:type", Array)
], BoostPortalChooseMembership.prototype, "selectedProperties", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalChooseMembership.prototype, "dropdownIsVisible", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('loggedInProfile')),
    state(),
    __metadata("design:type", ewExerciseProfileJson)
], BoostPortalChooseMembership.prototype, "loggedInProfile", void 0);
BoostPortalChooseMembership = __decorate([
    customElement(BoostPortalChooseMembership.is)
], BoostPortalChooseMembership);
export { BoostPortalChooseMembership };
